import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import styles from './Header.module.sass'
import Icon from '../Icon'
import Image from '../Image'
import User from './User'
import { Menu } from 'antd'
import ConnectMetamask from '../ConnectMetamask'
import config from '../../config'

const nav = [
  {
    url: '/search',
    title: 'Discover',
  },
  {
    url: '/upload-details',
    title: 'Launchpad',
  },
  /*{
    url: "https://www.youtube.com/watch?v=vKnsFGQDQkQ",
    title: "How it work",
  },*/
  {
    url: config.faucetUrl,
    title: 'Faucet',
  },
  /*{
    url: '/profile',
    title: 'Profile',
  },*/
]

const Headers = () => {
  const [visibleNav, setVisibleNav] = useState(false)
  const [search, setSearch] = useState('')

  const handleSubmit = (e) => {
    window.location.href = '/search?searchQuery=' + e.target.value
  }

  const subMenu = (
    <Menu>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href="https://uniswap.org/" onClick={() => setVisibleNav(false)}>
          Uniswap
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href="https://pancakeswap.finance/" onClick={() => setVisibleNav(false)}>
          Pancakeswap
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href="https://sushi.com/" onClick={() => setVisibleNav(false)}>
          Sushiswap
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href="https://www.probit.com/en-us/" onClick={() => setVisibleNav(false)}>
          Probit
        </a>
      </Menu.Item>
    </Menu>
  )

  return (
    <>
    <div className={styles.top}>
      <span>Need help? <a href="https://www.youtube.com/watch?v=3YF46OzJPP8" target="_blank" rel="noopener noreferrer">View video manual <img src="/images/content/icons/arrow.svg" alt=""/></a></span>
    </div>
    <header className={styles.header}>
      <div className={cn('container', styles.container)}>
        <a className={styles.logo} href="/" onClick={() => setVisibleNav(false)}>
          <Image
            className={cn(styles.pic, styles.pic_desktop)}
            src={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/logo.png'}
            srcDark={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/logo-dark.png'}
            alt={process.env.REACT_APP_TITLE}
          />
          <Image
            className={cn(styles.pic, styles.pic_mobile)}
            src={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/logo.png'}
            srcDark={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/logo-dark.png'}
            alt={process.env.REACT_APP_TITLE}
          />
        </a>
        <div className={cn(styles.wrapper, { [styles.active]: visibleNav })}>
          <nav className={styles.nav}>

            {nav.map((x, index) =>
              x.url.startsWith('http') ? (
                <a
                  className={styles.link}
                  href={x.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={index}
                  onClick={() => setVisibleNav(false)}
                >
                  {x.title}
                </a>
              ) : (
                <Link className={styles.link} to={x.url} key={index} onClick={() => setVisibleNav(false)}>
                  {x.title}
                </Link>
              )
            )}


            {/*<Dropdown overlay={subMenu} >
              <a className={cn("ant-dropdown-link", styles.link)} onClick={e => e.preventDefault()}>
                Get YoCoin &nbsp; <DownOutlined />
              </a>
            </Dropdown>*/}

          </nav>


          <form
            className={styles.search}
            action=""
            onSubmit={() => handleSubmit()}
          >
            <input
              className={styles.input}
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              name="search"
              placeholder="Search"
              required
            />
            <button className={styles.result}>
              <Icon name="search" size="20"/>
            </button>
          </form>
          <Link
            className={cn('button-small', styles.button)}
            to="/upload-details"
            onClick={() => setVisibleNav(false)}
          >
            Upload NFT
          </Link>
        </div>
        {/*<Notification className={styles.notification} />*/}
        <Link
          className={cn('button-small', styles.button)}
          to="/upload-details"
          onClick={() => setVisibleNav(false)}
        >
          Upload NFT
        </Link>
        <ConnectMetamask/>
        <User className={styles.user}/>
        <button
          className={cn(styles.burger, { [styles.active]: visibleNav })}
          onClick={() => setVisibleNav(!visibleNav)}
        >
          <span></span>
        </button>
      </div>
    </header>
    </>
  )
}

export default Headers
